import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";

export default function ProtectedAdminRoute({ children }) {
  const { admin, checking } = useAdminAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-linen" data-testid="admin-auth-checking">
        <div className="text-center">
          <div className="w-10 h-10 mx-auto rounded-full border-2 border-espresso/20 border-t-espresso animate-spin" />
          <p className="mt-3 text-xs uppercase tracking-[0.28em] text-espresso-muted">Đang xác thực…</p>
        </div>
      </div>
    );
  }

  if (!admin) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/admin/login?next=${next}`} replace />;
  }

  return children;
}
